import React, { useEffect, useState } from 'react'


import {
    loadCourses,
    loadUsers,
    filterUsers,
    loadAudience

} from "../../../utils/Network";

import SelectGender from '../../../components/SelectGender';
import SelectTalent from '../../../components/SelectTalent';
import SelectCourses from '../../../components/SelectCourses';
import SelectYear from '../../../components/SelectYear';
import SelectMonth from '../../../components/SelectMonth';
import SelectCities from '../../../components/SelectCities';
import SelectCountries from '../../../components/SelectCountries';
import WidgetContestReport from './widgets/WidgetContestReport';
import WidgetOnlineUsers from './widgets/WidgetOnlineUsers';
import WidgetParticipantsChart from './widgets/WidgetParticipantsChart';
import WidgetParticipantsMap from './widgets/WidgetParticipantsMap';
import WidgetDashboardStats from './widgets/WidgetDashboardStats';

export default function DashboardContent() {

    const [users_count, setUsersCount] = useState(null);
    const [course, setCourse] = useState(null);

    const [show_filter, setShowFilter] = useState(false);
    const [filter_course_value, setFilterCourseValue] = useState(null);
    const [filter_talent_value, setFilterTalentValue] = useState(null);
    const [filter_gender_value, setFilterGenderValue] = useState(null);
    const [filter_from_year_value, setFilterFromYearValue] = useState(null);
    const [filter_from_month_value, setFilterFromMonthValue] = useState(null);
    const [filter_to_year_value, setFilterToYearValue] = useState(null);
    const [filter_to_month_value, setFilterToMonthValue] = useState(null);
    const [filter_birth_country_value, setFilterBirthCountryValue] = useState(null);
    const [filter_birth_city_value, setFilterBirthCityValue] = useState(null);
    const [filter_living_country_value, setFilterLivingCountryValue] = useState(null);
    const [filter_living_city_value, setFilterLivingCityValue] = useState(null);

    const [allParticipants, setAllParticipants] = useState(null);
    const [worldMapInfo, setWorldMapInfo] = useState(null);
    const [onlineUsers, setOnlineUsers] = useState(null);
    const [audience_count, setAudienceCount] = useState(null);

    useEffect(() => {

        loadCourses().then(courses => {
            if (Array.isArray(courses) && courses.length > 0) {
                setCourse(courses[0]);
            }

        });

        // getJuryCount().then(count => {
        //     setjuryCount(count)
        // });


        loadUsers(1, 10).then((data) => {
            if (data && typeof data.count === "number") setUsersCount(data.count);
        });

        loadAudience(1, null).then((data) => {
            if (data && typeof data.count === "number") setAudienceCount(data.count);
        });

        _getAllParticipants()

    }, []);


    const _getAllParticipants = () => {

        filterUsers("&size=45000000", 1).then((response) => {
            if (response && response.results) {
                _OnlineUsers(response.results)
                setAllParticipants(response.results);
            }
        });
    }

    const _OnlineUsers = (participants) => {
        var online_users = []
        participants.forEach((obj) => {
            var last_online = obj.last_online;
            if (last_online) {
                var date_last_online = new Date(last_online);
                var now = new Date();
                var Difference_In_Time = now.valueOf() - date_last_online.valueOf();
                var Difference_In_MINS = Difference_In_Time / (1000 * 60);

                if (Difference_In_MINS < 300)
                    online_users.push(obj)
            }

        })
        setOnlineUsers(online_users)
    }



    const onValue = (value, name) => {
        // alert(name)
        switch (name) {
            case "course":
                setFilterCourseValue(value)
                break;
            case "talent":
                setFilterTalentValue(value)
                break;
            case "from_year":
                setFilterFromYearValue(value)
                break;
            case "from_month":
                setFilterFromMonthValue(value)
                break;
            case "to_year":
                setFilterToYearValue(value)
                break;
            case "to_month":
                setFilterToMonthValue(value)
                break;
            case "gender":
                setFilterGenderValue(value)
                break;
            case "country":
                setFilterBirthCountryValue(value)
                break;
            case "city":
                setFilterBirthCityValue(value)
                break;
            case "living_country":
                setFilterLivingCountryValue(value)
                break;
            case "living_city":
                setFilterLivingCityValue(value)
                break;
            default:
                break;
        }
    }

    return (
        <>
            <div className="content-wrapper">
                
                <section className="content">
                  <div className="container-fluid" style={{ maxWidth: '1400px' }}>

                    <div className={` filters ${show_filter ? "" : "hided"}`}>

                        <div className="box box-primary">
                            <div className="box-header with-border">
                                <h3 className="box-title">Filters</h3>
                            </div>
                            <form action="users" className="form-horizontal">
                                <div className="box-body">
                                    <div className="mb-10">
                                        <div className="col-md-7 padding-l-0 ">
                                            <div className="col-md-6 padding-0 mb-10 padding-r-5">
                                                <input type="text" name="first_name" className="form-control" placeholder="First Name" />
                                            </div>
                                            <div className="col-md-6 mb-10  padding-0 ">
                                                <input type="text" name="last_name" className="form-control" placeholder="Last Name" />

                                            </div>
                                            <div className="col-md-12 padding-0">
                                                <div className="pull-left margin-r-10 mb-10 padding-0">
                                                    <SelectGender width="130px" border="1" value={filter_gender_value} callback={onValue} />
                                                    <input type="hidden" name="gender" value={filter_gender_value} />
                                                </div>
                                                <div className="pull-left margin-r-10 mb-10 padding-0">
                                                    <SelectTalent value={filter_talent_value} width="180px" border="1" callback={onValue} />
                                                    <input type="hidden" name="talent" value={filter_talent_value} />
                                                </div>
                                                <div className="pull-left margin-r-10 mb-10 padding-0">
                                                    <SelectCourses value={filter_course_value} width="200px" border="1" callback={onValue} />
                                                    <input type="hidden" name="course" value={filter_course_value} />
                                                </div>
                                            </div>
                                            <div className="clear"></div>
                                        </div>
                                        <div className="col-md-5 padding-10" style={{ backgroundColor: '#374355', color: 'white' }}>
                                            <div className="row">
                                                <label className="col-lg-12">Date of Birth</label>
                                                <div className="col-lg-6 col-sm-12 padding-r-0 ">
                                                    <label className="col-lg-12 padding-0">From</label>
                                                    <div className="col-lg-12  padding-0">
                                                        <div className="pull-left">
                                                            <SelectYear value={filter_from_year_value} name="from_year" width="80px" border="1" callback={onValue} />
                                                            <input type="hidden" name="from_year" value={filter_from_year_value} />

                                                        </div>
                                                        <div className="pull-left margin-l-5">
                                                            <SelectMonth value={filter_from_month_value} name="from_month" width="95px" border="1" callback={onValue} />
                                                            <input type="hidden" name="from_month" value={filter_from_month_value} />
                                                        </div>
                                                    </div>
                                                    <div className="clear"></div>
                                                </div>
                                                <div className="col-lg-6  col-sm-12 padding-r-0">
                                                    <label className="col-lg-12 padding-0">To</label>
                                                    <div className="col-lg-12 padding-0">
                                                        <div className="pull-left">
                                                            <SelectYear value={filter_to_year_value} name="to_year" width="80px" border="1" callback={onValue} />
                                                            <input type="hidden" name="to_year" value={filter_to_year_value} />
                                                        </div>
                                                        <div className="pull-left margin-l-5">
                                                            <SelectMonth value={filter_to_month_value} name="to_month" width="95px" border="1" callback={onValue} />
                                                            <input type="hidden" name="to_month" value={filter_to_month_value} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="clear"></div>
                                    </div>
                                    <div className="">
                                        <div className="col-md-6 padding-10" style={{ backgroundColor: '#374355', color: 'white' }}>
                                            <div className="col-md-12 padding-0">
                                                <label>Born in</label>
                                            </div>
                                            <div className="pull-left margin-r-10 mb-10">
                                                <SelectCountries kurds={1} value={filter_birth_country_value} name="country" width="220px" border="1" callback={onValue} />
                                                <input type="hidden" name="country" value={filter_birth_country_value} />
                                            </div>
                                            <div className="pull-left ">
                                                <SelectCities country={filter_birth_country_value} key={filter_birth_country_value} value={filter_birth_city_value} name="city" width="220px" border="1" callback={onValue} />
                                                <input type="hidden" name="city" value={filter_birth_city_value} />
                                            </div>
                                            <div className="clear"></div>
                                        </div>
                                        <div className="col-md-6  padding-0 " style={{ backgroundColor: '#374355', color: 'white' }}>
                                            <div className="padding-10 padding-l-5">
                                                <div className="col-md-12 padding-0">
                                                    <label>Living in</label>
                                                </div>
                                                <div className="pull-left margin-r-10 mb-10 ">
                                                    <SelectCountries value={filter_living_country_value} name="living_country" width="210px" border="1" callback={onValue} />
                                                    <input type="hidden" name="living_country" value={filter_living_country_value} />
                                                </div>
                                                <div className="pull-left ">
                                                    <SelectCities country={filter_living_country_value} key={filter_living_country_value} value={filter_living_city_value} name="living_city" width="210px" border="1" callback={onValue} />
                                                    <input type="hidden" name="living_city" value={filter_living_city_value} />
                                                </div>
                                                <div className="clear"></div>
                                            </div>
                                            <div className="clear"></div>
                                        </div>
                                        <div className="clear"></div>
                                    </div>


                                </div>
                                <div className="box-footer">
                                    <button type="submit" className="btn btn-primary pull-right">Filter</button>
                                    <button type="button" className="btn btn-secondary pull-right mr-1" onClick={() => { setShowFilter(false) }}>Cancel</button>
                                </div>
                            </form>
                        </div>


                    </div>

                    <div className="box box-primary">
                        <div className="box-header with-border">
                            <h3 className="box-title">Dashboard</h3>
                            <button
                                type="button"
                                title="Toggle filters"
                                className="btn btn-cm margin-r-5 pull-right"
                                onClick={() => { setShowFilter(!show_filter) }}
                            >
                                <i className="fa fa-search"></i>
                            </button>
                        </div>
                        <div className="box-body">
                    <div className="row">
                    <section className="col-lg-6 connectedSortable">
                            <WidgetOnlineUsers />
                           
                            
                    </section>
                    <section className="col-lg-6 connectedSortable">

                        <WidgetParticipantsChart />
                        <WidgetParticipantsMap
                            participants={allParticipants}
                            worldMapInfo={worldMapInfo}
                            onWorldMapInfoChange={setWorldMapInfo}
                        />
                        </section>

                        <section className="col-lg-6 connectedSortable ui-sortable">
                            {/* <WidgetLatestMembers /> */}
                            
                            {/* <WidgetCourseParticipants /> */}
                        </section>

                        {/* <section className="col-lg-6 connectedSortable">
                            <div className="box box-success">
                                <div className="box-header no-bg">
                                    <h3 className="box-title color-dark">{course && getDefaultName(course.names)} Participants </h3>

                                    <div className="box-tools pull-right">
                                        <button type="button" className="btn btn-box-tool" data-widget="collapse"><i className="fa fa-minus"></i>
                                        </button>
                                        <button type="button" className="btn btn-box-tool" data-widget="remove"><i className="fa fa-times"></i></button>
                                    </div>
                                </div>
                                <div className="box-body chart-responsive">
                                    <DashboardCourseBarChart courseId={course && course.id} key={course} />
                                </div>

                            </div>
                        </section> */}



                        

                    </div>

                    <WidgetDashboardStats
                        usersCount={users_count}
                        audienceCount={audience_count}
                        course={course}
                        onlineUsersCount={onlineUsers ? onlineUsers.length : 0}
                    />
                        <WidgetContestReport />
                        </div>
                    </div>

                  </div> {/* /container-fluid */}
                </section>
            </div>
        </>


    )
}
